module.exports = __webpack_public_path__ + "static/media/fly0060.32c8d938.webp";